import { HelpBlock } from 'pages/MainPage/blocks/HelpBlock';

import { connector } from './connector';

export const HelpSection = connector(HelpBlock);
